"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.teamOf = teamOf;
exports.nextPlayer = nextPlayer;
exports.partnerOf = partnerOf;
exports.sameColor = sameColor;
exports.effectiveSuit = effectiveSuit;
exports.cardStrength = cardStrength;
exports.legalCards = legalCards;
exports.trickWinner = trickWinner;
exports.scoreHand = scoreHand;
exports.createDeck = createDeck;
exports.shuffledDeck = shuffledDeck;
const Types_1 = require("./Types");
const PRNG_1 = require("./utils/PRNG");
function teamOf(playerIndex) {
    return playerIndex % 2 === 0 ? 0 : 1;
}
function nextPlayer(playerIndex) {
    return playerIndex === 3 ? 0 : playerIndex + 1;
}
function partnerOf(playerIndex) {
    return nextPlayer(nextPlayer(playerIndex));
}
function sameColor(a, b) {
    return (a === Types_1.Suit.HEARTS || a === Types_1.Suit.DIAMONDS) === (b === Types_1.Suit.HEARTS || b === Types_1.Suit.DIAMONDS);
}
function effectiveSuit(card, trump) {
    return card.rank === Types_1.Rank.JACK && sameColor(card.suit, trump) ? trump : card.suit;
}
function cardStrength(card, trump, ledSuit) {
    if (effectiveSuit(card, trump) === trump) {
        if (card.rank === Types_1.Rank.JACK)
            return card.suit === trump ? 107 : 106;
        return 80 + card.rank;
    }
    return (card.suit === ledSuit ? 30 : 0) + card.rank;
}
function legalCards(hand, trick, trump) {
    if (trick.length === 0)
        return [...hand];
    const ledSuit = effectiveSuit(trick[0].card, trump);
    const following = hand.filter(card => effectiveSuit(card, trump) === ledSuit);
    return following.length > 0 ? following : [...hand];
}
function trickWinner(trick, trump) {
    if (trick.length === 0)
        throw new Error("Cannot determine the winner of an empty trick");
    const ledSuit = effectiveSuit(trick[0].card, trump);
    return trick.reduce((best, play) => cardStrength(play.card, trump, ledSuit) > cardStrength(best.card, trump, ledSuit) ? play : best).playerIndex;
}
function scoreHand(makerIndex, tricks, alone) {
    if (!tricks.every(value => Number.isInteger(value) && value >= 0) || tricks[0] + tricks[1] !== 5) {
        throw new Error("A completed hand must contain exactly five tricks");
    }
    const makerTeam = teamOf(makerIndex);
    const euchred = tricks[makerTeam] < 3;
    const winningTeam = euchred ? (makerTeam === 0 ? 1 : 0) : makerTeam;
    return {
        makerIndex, makerTeam, winningTeam, alone, euchred, tricks: [...tricks],
        points: euchred ? 2 : tricks[makerTeam] === 5 ? (alone ? 4 : 2) : 1
    };
}
function createDeck() {
    return Types_1.SUITS.flatMap((suit, suitIndex) => [9, 10, 11, 12, 13, 14].map((rank, index) => ({
        id: suitIndex * 6 + index, suit, rank
    })));
}
function shuffledDeck(seed, handNumber) {
    if (!Number.isSafeInteger(handNumber) || handNumber < 1)
        throw new Error("handNumber must be a positive safe integer");
    const prng = new PRNG_1.PRNG(seed);
    for (let hand = 1; hand < handNumber; hand++)
        prng.shuffleArray(createDeck());
    return prng.shuffleArray(createDeck());
}
